module.exports = __webpack_public_path__ + "static/media/veneto-3-03.781730c9.jpg";